// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { type VBackendMessageBodyArray } from '../../execute-tunnel-placement-stage.ts';

import { AssertError } from '@atlassian/vindicated';
export function assert(value: any): VBackendMessageBodyArray {
    const result = validate(value);
    if (!result.success) {
        const firstError = result.errors[0];
        throw new AssertError('assert', firstError.path, firstError.expected, firstError.value);
    }
    return result.data as VBackendMessageBodyArray;
}
export { assert as assertVBackendMessageBodyArray };


export function is(value: any): value is VBackendMessageBodyArray {
	const result = validate(value);
    return result.success;
}
export { is as isVBackendMessageBodyArray };


import { type ValidationResult } from '@atlassian/vindicated';
function validateSerializablePayload(value: any): ValidationResult<unknown> {
	const errors = [];
	
    {
        let value_valid = false;
        
        if (!value_valid) {
            const value_errors_0 = [];
            if (typeof value !== 'string') value_errors_0.push({ path: 'value', expected: 'string', value: value });
            if (value_errors_0.length === 0) {
                value_valid = true;
            }
        }

        if (!value_valid) {
            const value_errors_1 = [];
            if (typeof value !== 'number') value_errors_1.push({ path: 'value', expected: 'number', value: value });
            if (value_errors_1.length === 0) {
                value_valid = true;
            }
        }

        if (!value_valid) {
            const value_errors_2 = [];
            if (typeof value !== 'boolean') value_errors_2.push({ path: 'value', expected: 'boolean', value: value });
            if (value_errors_2.length === 0) {
                value_valid = true;
            }
        }

        if (!value_valid) {
            const value_errors_3 = [];
            if (value !== null) value_errors_3.push({ path: 'value', expected: 'null', value: value });
            if (value_errors_3.length === 0) {
                value_valid = true;
            }
        }

        if (!value_valid) {
            const value_errors_4 = [];
            if (typeof value !== "undefined") value_errors_4.push({ path: 'value', expected: 'undefined', value: value });
            if (value_errors_4.length === 0) {
                value_valid = true;
            }
        }

        if (!value_valid) {
            const value_errors_5 = [];
            
	if (typeof value !== 'object' || value === null || Array.isArray(value)) {
        value_errors_5.push({ path: 'value', expected: 'object', value: value });
    } else {
            for (const key in value) {
                if (value.hasOwnProperty(key)) {
                    if (typeof key !== 'string') value_errors_5.push({ path: 'key', expected: 'string', value: key });
                    const recursiveResult = validateSerializablePayload(value[key]);
                    if (!recursiveResult.success) value_errors_5.push(...recursiveResult.errors.map(err => ({...err, path: `value["${key}"]${err.path.slice('value'.length)}`})));
                }
            }
    }
            if (value_errors_5.length === 0) {
                value_valid = true;
            }
        }

        if (!value_valid) {
            const value_errors_6 = [];
            if (!Array.isArray(value)) value_errors_6.push({ path: 'value', expected: 'array', value: value });
            if (value_errors_6.length === 0) {
                value_valid = true;
            }
        }
        if (!value_valid) {
            errors.push({ path: 'value', expected: 'string | number | boolean | null | undefined | object | SerializablePayload[]', value: value });
        }
    }
	if (errors.length === 0) return { success: true, data: value };
	return { success: false, data: value, errors: errors };
}
export function validate(value: any): ValidationResult<VBackendMessageBodyArray> {
    const errors = [];
    const originalData = value;
    
	if (typeof value !== 'object' || value === null || Array.isArray(value)) {
        errors.push({ path: 'value', expected: 'VBackendMessageBodyArray', value: value });
    } else {
			if (!('messages' in value)) {
				errors.push({ path: 'value["messages"]', expected: 'SerializableRecord[]', value: undefined });
			} else {
				if (!Array.isArray(value["messages"])) errors.push({ path: 'value["messages"]', expected: 'array', value: value["messages"] });if (Array.isArray(value["messages"])) { value["messages"].forEach((element, index) => { 
	if (typeof element !== 'object' || element === null || Array.isArray(element)) {
        errors.push({ path: 'element', expected: 'SerializableRecord', value: element });
    } else {
	    for (const key1 in element) {
	        if (element.hasOwnProperty(key1)) {
	            if (typeof key1 !== 'string') errors.push({ path: 'key1', expected: 'string', value: key1 });

				const currentLevelErrors = [];
				
    {
        let element_key1__valid = false;
        
        if (!element_key1__valid) {
            const element_key1__errors_0 = [];
            if (typeof element[key1] !== 'string') element_key1__errors_0.push({ path: 'element[key1]', expected: 'string', value: element[key1] });
            if (element_key1__errors_0.length === 0) {
                element_key1__valid = true;
            }
        }

        if (!element_key1__valid) {
            const element_key1__errors_1 = [];
            if (typeof element[key1] !== 'number') element_key1__errors_1.push({ path: 'element[key1]', expected: 'number', value: element[key1] });
            if (element_key1__errors_1.length === 0) {
                element_key1__valid = true;
            }
        }

        if (!element_key1__valid) {
            const element_key1__errors_2 = [];
            if (typeof element[key1] !== 'boolean') element_key1__errors_2.push({ path: 'element[key1]', expected: 'boolean', value: element[key1] });
            if (element_key1__errors_2.length === 0) {
                element_key1__valid = true;
            }
        }

        if (!element_key1__valid) {
            const element_key1__errors_3 = [];
            if (element[key1] !== null) element_key1__errors_3.push({ path: 'element[key1]', expected: 'null', value: element[key1] });
            if (element_key1__errors_3.length === 0) {
                element_key1__valid = true;
            }
        }

        if (!element_key1__valid) {
            const element_key1__errors_4 = [];
            if (typeof element[key1] !== "undefined") element_key1__errors_4.push({ path: 'element[key1]', expected: 'undefined', value: element[key1] });
            if (element_key1__errors_4.length === 0) {
                element_key1__valid = true;
            }
        }

        if (!element_key1__valid) {
            const element_key1__errors_5 = [];
            
	if (typeof element[key1] !== 'object' || element[key1] === null || Array.isArray(element[key1])) {
        element_key1__errors_5.push({ path: 'element[key1]', expected: 'object', value: element[key1] });
    } else {
            for (const key2 in element[key1]) {
                if (element[key1].hasOwnProperty(key2)) {
                    if (typeof key2 !== 'string') element_key1__errors_5.push({ path: 'key2', expected: 'string', value: key2 });
                    const recursiveResult = validateSerializablePayload(element[key1][key2]);
                    if (!recursiveResult.success) element_key1__errors_5.push(...recursiveResult.errors.map(err => ({...err, path: `element[key1]["${key2}"]${err.path.slice('value'.length)}`})));
                }
            }
    }
            if (element_key1__errors_5.length === 0) {
                element_key1__valid = true;
            }
        }

        if (!element_key1__valid) {
            const element_key1__errors_6 = [];
            if (!Array.isArray(element[key1])) element_key1__errors_6.push({ path: 'element[key1]', expected: 'array', value: element[key1] });
            if (element_key1__errors_6.length === 0) {
                element_key1__valid = true;
            }
        }
        if (!element_key1__valid) {
            currentLevelErrors.push({ path: 'element[key1]', expected: 'string | number | boolean | null | undefined | object | SerializablePayload[]', value: element[key1] });
        }
    }
				errors.push(...currentLevelErrors.map(err => ({...err, path: `element["${key1}"]`})));
	        }
	    }
    } }); }
			}
    }
    if (errors.length === 0) return { success: true, data: value };
    return { success: false, data: originalData, errors: errors };
}
export { validate as validateVBackendMessageBodyArray };
